import MousePosition from 'ol/control/MousePosition';
import { MAP_TIME } from '../time/time';

import { faHistory } from '@fortawesome/pro-solid-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core'

import { formatDateTime } from '../../i18n/format';

class TimePosition extends MousePosition {
	
	constructor(opt_options) {
		super(opt_options);		
		
		this.htmlIcon = icon(faHistory).html[0]
	}
				
	updateHTML_() {
		const map = this.getMap();
		if( map ) {
			const time = map.get(MAP_TIME);
			const element = this.element;				
				
			if( time && element.style.display === "none" ) {
				element.style.display = "";
			} else if( !time && element.style.display === "" ) {
				element.style.display = "none";
			}
				
			if( time ) {
				this.element.innerHTML = this.htmlIcon + " "  + formatDateTime(time);
			} else {
				this.element.innerHTML = "";
			}
		}
	}	
}

const timePosition = (target) => {
	return new TimePosition({
        placeholder: false, // keeps last coordinate visible
        target: target
    });  
}

export {
	timePosition
}